import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const insightMono = { fontFamily: 'ui-monospace, Menlo, Consolas, monospace' };

const card = {
  borderRadius: 8,
  padding: '10px 12px',
  fontSize: 11,
  lineHeight: 1.35,
};

const sectionTitle = {
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  marginBottom: 4,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  color: '#9f1239',
};

function CallOpenInsightCard({ trimmedLocation, locationSelected, onTimerTextChange }) {
  const [callSeconds, setCallSeconds] = useState(0);

  useEffect(() => {
    if (!trimmedLocation || !locationSelected) {
      setCallSeconds(0);
      return undefined;
    }
    const id = setInterval(() => setCallSeconds((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, [trimmedLocation, locationSelected]);


  const mm = String(Math.floor(callSeconds / 60)).padStart(2, '0');
  const ss = String(callSeconds % 60).padStart(2, '0');
  const timerText = `${mm}:${ss}`;

  useEffect(() => {
    if (typeof onTimerTextChange === 'function') {
      onTimerTextChange(timerText);
    }
  }, [onTimerTextChange, timerText]);

  return (
    <div style={{ ...card, background: '#ffe4e6', border: '1px solid #fda4af' }}>
      <div style={sectionTitle}>
        <i className="fa fa-clock-o" aria-hidden />
        <span>Call open</span>
      </div>
      <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: 2, color: '#be123c', ...insightMono }}>
        {timerText}
      </div>
    </div>
  );
}

CallOpenInsightCard.propTypes = {
  trimmedLocation: PropTypes.string.isRequired,
  locationSelected: PropTypes.bool.isRequired,
  onTimerTextChange: PropTypes.func,
};

export default CallOpenInsightCard;
